/* src/components/item-status/item-status.component.scss */
:host {
  display: block;
}
.item-status {
  position: relative;
  z-index: 1;
  border: var(--vwui-border-base);
  border-color: var(--vwui-table--border-color, var(--vwui--color--border-light));
  border-radius: var(--vwui--radius--md);
  display: block;
  box-shadow: var(--vwui--shadow--md);
}
.item-status--disabled {
  background: var(--vwui-color-neutral-4);
}
.item-status--checked {
  border-bottom: 3px solid var(--vwui-color-success);
}
.item-status--alert {
  border-bottom: 3px solid var(--vwui-color-danger);
}
.item-status__content {
  padding: 1.25rem var(--vwui--spacing--lg);
}
.item-status__status {
  float: left;
  margin: 0.2rem 0.5rem 0 0;
  border-radius: 50%;
  width: 1rem;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
}
.item-status__status vwui-icon {
  display: inline-block;
  vertical-align: top;
  color: inherit;
}
.item-status__status--checked {
  background: var(--vwui-color-success);
  color: #fff;
}
.item-status__status--checked vwui-icon {
  margin: 0.2rem 0 0 0.05rem;
  --vwui-icon--size: 0.6rem;
}
.item-status__status--alert {
  color: var(--vwui-color-danger);
}
.item-status__status--alert vwui-icon {
  --vwui-icon--size: 1rem;
}
/*# sourceMappingURL=item-status.component-GZA6YFTO.css.map */
